module.exports = __webpack_public_path__ + "media/entities/1611-3193f7da.png";